import { KnownLDFlagKeys, KnownLDFlags, selectLDFlag } from "app/store/LDFeatureFlagsSlice";

import useStaticStores from "./store/useStaticStores";

const useLDFlag = <F extends KnownLDFlagKeys>(flag: F): KnownLDFlags[F] => {
  return useStaticStores((state) => selectLDFlag(state, flag)) as KnownLDFlags[F];
};

export default useLDFlag;
